import { render, staticRenderFns } from "./Speciaux.vue?vue&type=template&id=b09e1d4a"
import script from "./Speciaux.vue?vue&type=script&lang=js"
export * from "./Speciaux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports